import React from "react";

import type {
  ProcessedPickemSelection,
  ProcessedSelection,
} from "@/hooks/firestore/betting/useEntries";

import cx from "classnames";
import { StreamButton } from "@/features/shell/components/shared/StreamButton";
import { Live } from "@picklebet/ui";
import { isPickemsSelection } from "../../util/type-guards";

import * as styles from "./LiveClampWithStream.module.scss";

type ILiveClampWithStream = {
  isLive: boolean;
  selection: ProcessedSelection | ProcessedPickemSelection;
  className?: string;
};

const LiveClampWithStream = (props: ILiveClampWithStream) => {
  const { isLive, selection, className } = props;

  if (isPickemsSelection(selection)) {
    return isLive ? <Live /> : null;
  }

  return (
    <>
      {isLive && selection.event.streamUri ? (
        <div className={cx(styles.root, className)}>
          <StreamButton
            title={selection.event.eventName ?? ""}
            sport={selection.event.sport}
            url={selection.event.streamUri}
            startTime={new Date(selection.event.scheduledStartTime ?? "")}
            eventId={selection.event.eventId}
            isPlaceholder={!!selection.event.attributes.streamExpected}
          />
          <Live />
        </div>
      ) : (
        isLive && !selection.event.streamUri && <Live />
      )}
    </>
  );
};

export { LiveClampWithStream };
